import {handleActions, createAction} from 'redux-actions';

const LOADING = '@nezzokontikifrontend/System/LOADING';

export const actionTypes = {
	LOADING
};
const loading = createAction(LOADING, (loading, action) => {
	return {loading: loading, action: action};
});

export const actions = {
	loading
};

const defaultState = {
	loading: {
		pagination: false,
		filter: false
	}
};

export const reducer = handleActions({
	[LOADING]: (state, action) => {
		let newLoadingState = {...state.loading};
		newLoadingState[action.payload.action] = action.payload.loading;
		return {...state, loading: newLoadingState}
	}
}, defaultState);


// WEBPACK FOOTER //
// ./src/reducers/system.js